import {CommentDiscussionIcon} from '@primer/octicons-react'
import styles from './UnresolvedConversations.module.css'
import conversationStyles from './ConversationList.module.css'
import {Link, RelativeTime} from '@primer/react'
import type {InfographicDataPoint} from '../types'
import {createRelativeTimeProps, pluralize} from '../helpers/infographic-helpers'

interface UnresolvedConversationsProps {
  count?: number
  conversations?: InfographicDataPoint[]
}

const DEFAULT_CONVERSATIONS: UnresolvedConversationsProps['conversations'] = []

export function UnresolvedConversations({
  count = 0,
  conversations = DEFAULT_CONVERSATIONS,
}: UnresolvedConversationsProps) {
  return conversations && conversations.length > 0 ? (
    <section className={styles.section}>
      <div>
        <h3 className={conversationStyles.conversationListHeading} id="unresolved-conversations">
          <span className={conversationStyles.inner}>
            <CommentDiscussionIcon className="color-fg-muted" /> <strong className="color-fg-default">{count}</strong>{' '}
            {pluralize(count, 'Unresolved conversation', 'Unresolved conversations')}
          </span>
        </h3>
      </div>

      <p className={styles.description}>
        Sometimes conversations happen on old items that aren&apos;t yet closed. Here is a list of all the Issues and
        Pull Requests with unresolved conversations.
      </p>

      <ul className="list-style-none tmp-my-4">
        {conversations ? (
          conversations.map(conversation => (
            <li key={conversation.number} className="clearfix">
              <CommentDiscussionIcon className={`${styles.icon} float-left mt-1`} />{' '}
              <div className="overflow-hidden pl-2">
                <Link href={conversation.path} className="h4 Link--primary mb-1 markdown-title">
                  {conversation.title}
                </Link>
                <p className="color-fg-muted text-small">
                  {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
                  <span className="num">#{conversation.number}</span> commented on{' '}
                  <RelativeTime {...createRelativeTimeProps(conversation.createdAt)} /> • {conversation.commentsCount}{' '}
                  {pluralize(conversation.commentsCount ?? 0, 'new comment', 'new comments')}
                </p>
              </div>
            </li>
          ))
        ) : (
          <li className="clearfix">
            <CommentDiscussionIcon className={`${styles.icon} float-left mt-1`} />{' '}
            <div className="overflow-hidden pl-2">
              <a href="filler" className="h4 Link--primary mb-1 markdown-title">
                [Example discussion]
              </a>
              <p className="color-fg-muted text-small">
                {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
                <span className="num">#0000</span> commented on yesterday • -- new comment(s)
              </p>
            </div>
          </li>
        )}
      </ul>
    </section>
  ) : null
}
